import React from "react";
import { ContentRowInformation } from "../../types/statusTypes";
import StatusLabel from "./StatusLabel";
import { useNavigate } from "react-router-dom";

interface RowProps {
  rowData: ContentRowInformation;
}

export default function Row({ rowData }: RowProps) {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`./asset/${rowData.contentId}`);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      handleRowClick();
    }
  };

  return (
    <tr onClick={() => handleRowClick()} onKeyDown={handleKeyDown} tabIndex={0}>
      <td>{rowData.version || rowData.contentId}</td>
      <td><StatusLabel statusText={rowData.redbeeStatus} /></td>
      <td><StatusLabel statusText={rowData.apolloStatus} /></td>
      <td><StatusLabel statusText={rowData.hbbtvStatus} /></td>
      <td><StatusLabel statusText={rowData.hydraDashStatus} /></td>
      <td><StatusLabel statusText={rowData.hydraHlsStatus} /></td>
    </tr>
  );
}
